import { useCallback, useEffect } from "react";
import "./Dashboard.scss";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import DashboardFilter from "./DashboardFilter";
import OpenATECases from "./OpenATECases";
import MaintenanceRequests from "./MaintenanceRequests";
import {
  getATECasesStatistics, getBuildingsStatistics, getContractInformationStatistics,
  getDashboardCards, getMaintenanceAppointmentsStatistics,
  resetFilterData,
} from "src/redux/slices/dashboardSlice";
import { getMaintenanceRequestsStatistics } from "src/redux/slices/dashboardSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import DashboardSLACard from "./DashboardSLACard";
import DashboardResolutionTimeCard from "./DashboardResolutionTimeCard";
import DashboardCasesSummaryCard from "./DashboardCasesSummaryCard";
import DashboardCompanyReviewCard from "./DashboardCompanyReviewCard";
import AssignedPropertiesCard from "./AssignedPropertiesCard";
import ContractsCard from "./ContractsCard";
import PreventiveMaintenanceAppointmentsCard from "./PreventiveMaintenanceAppointmentsCard";
import { getAssignedBuildingsLookup } from "src/redux/slices/lookupSlice";
import useOnPageLeave from "src/hooks/useOnPageLeave";
Chart.register(CategoryScale);

const Dashboard = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "dashboard"]);
  useEffect(() => {
    dispatch(getMaintenanceRequestsStatistics() as any);
    dispatch(getContractInformationStatistics() as any);
    dispatch(getATECasesStatistics() as any);
    dispatch(getDashboardCards() as any);
    dispatch(getBuildingsStatistics() as any);
    dispatch(getMaintenanceAppointmentsStatistics() as any);
    dispatch(getAssignedBuildingsLookup() as any);
  }, [dispatch]);


  const onPageLeave = useCallback(() => {
    dispatch(resetFilterData());
  }, []);
useOnPageLeave(onPageLeave);

  return (
    <div className="flex justify-between dashboard">
      <div className="">
        <div className="dashboard-outer-container">
          <div className="dashboard-inner-container">
            <div className="dashboard-filter mb-3">
              <DashboardFilter />
            </div>

            <div className="card-container">
              <div className="row mb-3">
                <DashboardSLACard />
                <DashboardResolutionTimeCard />
                <DashboardCasesSummaryCard />
                <DashboardCompanyReviewCard title={t("companyReview")} />
              </div>
              <div className="row chart-carts  mb-3">
                <OpenATECases title={t("bmcDashboardSystemFaults")} />
                <MaintenanceRequests />
              </div>
              <div className="row chart-carts">
                <PreventiveMaintenanceAppointmentsCard />
                <ContractsCard />
                <AssignedPropertiesCard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
